/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ orderNumber: NonNullable<unknown>, currentCarrier: NonNullable<unknown>, nextCarrier: NonNullable<unknown> }} Orders_Carrier_Change_SummaryInputs */

const en_orders_carrier_change_summary = /** @type {(inputs: Orders_Carrier_Change_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Order ${i?.orderNumber}: ${i?.currentCarrier} -> ${i?.nextCarrier}`)
};

const es_orders_carrier_change_summary = /** @type {(inputs: Orders_Carrier_Change_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pedido ${i?.orderNumber}: ${i?.currentCarrier} -> ${i?.nextCarrier}`)
};

/**
* | output |
* | --- |
* | "Order {orderNumber}: {currentCarrier} -> {nextCarrier}" |
*
* @param {Orders_Carrier_Change_SummaryInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_carrier_change_summary = /** @type {((inputs: Orders_Carrier_Change_SummaryInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Carrier_Change_SummaryInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_carrier_change_summary(inputs)
	return es_orders_carrier_change_summary(inputs)
});